import React, { useState } from 'react';
const faqs = ['¿Cómo recibo el MegaPack después de comprar?', '¿Sirve para profes particulares o solo para clubes?', '¿Es editable? ¿Puedo modificarlo?', '¿Los 6 bonos están en las dos ofertas?', '¿Sirve si soy profe nuevo con poca experiencia enseñando?', '¿Sirve para alumnos de todas las edades?', '¿Qué pasa si tengo alumnos de distintos niveles al mismo tiempo?', '¿Qué diferencia tiene el MegaPack con otros materiales de pádel?', '¿Por qué elegir el Combo Completo y no el estándar?', '¿Tiene garantía real?'];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(248, 250, 252)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-141">
      <div className="mx-auto max-w-3xl" data-id="element-142">
        <h2 className="text-3xl font-black text-center leading-10 text-gray-900 m-0 mb-8" data-id="element-143">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2" data-id="element-144">
          {faqs.map((question, i) => <div key={i} className="bg-white transition-colors border border-cyan-brand/30 rounded-lg shadow-sm" data-id="element-145">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-4 py-3 m-0" style={{
            fontFamily: 'inherit'
          }} data-id="element-146">
                <span className="text-sm font-bold text-gray-900" data-id="element-147">
                  ❓ {i + 1} — {question}
                </span>
                <span className={`shrink-0 text-lg text-cyan-brand transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-148">
                  +
                </span>
              </button>
            </div>)}
        </div>
      </div>
    </section>;
}